import { render, staticRenderFns } from "./CustomFieldTemplate.vue?vue&type=template&id=2f0017fd&"
import script from "./CustomFieldTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomFieldTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0017fd')) {
      api.createRecord('2f0017fd', component.options)
    } else {
      api.reload('2f0017fd', component.options)
    }
    module.hot.accept("./CustomFieldTemplate.vue?vue&type=template&id=2f0017fd&", function () {
      api.rerender('2f0017fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomField/CustomFieldTemplate.vue"
export default component.exports